import { Pipe, PipeTransform } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

@Pipe({
    name: 'stepForm',
    standalone: true,
})
export class StepFormPipe implements PipeTransform {

    public transform(form: FormArray, index: number): FormGroup {
        return form.at(index) as FormGroup;
    }

}
